import React, { useEffect, useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import uploadService from "../../api/services/uploadService";

const Editor = ({ data, onChange }) => {
  const [editorValue, setEditorValue] = useState("");
  const quillRef = useRef(null);

  const handleChange = (html) => {
    setEditorValue(html);
    onChange && onChange(html);
  };

  useEffect(() => {
    if (data?.descriptionData) {
      setEditorValue(data.descriptionData);
    }
  }, [data]);

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const toolbar = quill.getModule("toolbar");

      // Override the image handler
      toolbar.addHandler("image", () => {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.click();

        input.onchange = async () => {
          const file = input.files?.[0];
          if (!file) return;

          // Show loading indicator
          const range = quill.getSelection(true);
          quill.insertText(range.index, "\n[Uploading image...]\n", "user");
          quill.setSelection(range.index + 25);

          try {
            // Upload image to S3 via backend
            const response = await uploadService.editorImage(file);
            const imageUrl = response.imageUrl;

            if (imageUrl) {
              // Remove loading text and insert image
              quill.deleteText(range.index, 25);
              quill.insertEmbed(range.index, "image", imageUrl, "user");
              quill.setSelection(range.index + 1);
            } else {
              throw new Error("No image URL returned from server");
            }
          } catch (error) {
            console.error("Image upload error:", error);
            // Remove loading text and show error
            quill.deleteText(range.index, 25);
            quill.insertText(
              range.index,
              "\n[Image upload failed. Please try again.]\n",
              "user"
            );
            alert("Failed to upload image. Please try again.");
          }
        };
      });
    }
  }, []);

  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }, { header: [1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [{ direction: "rtl" }, { align: [] }],
      ["link", "image", "clean"],
    ],
  };

  return (
    <div>
      <ReactQuill
        ref={quillRef}
        value={editorValue}
        modules={modules}
        onChange={handleChange}
        placeholder="Write here ......"
      />
    </div>
  );
};

export default Editor;
